import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles, Clock } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GA4_PROMO_EVENTS = { banner_view: "view_promotion", banner_click: "select_promotion", book_now_click: "select_promotion" };

const track = (event) => {
  try {
    trackEvent(GA4_PROMO_EVENTS[event] || "view_promotion", {
      promotion_name: "Wednesday Silk Press Special",
      creative_slot: event,
    });
  } catch (e) { /* tracking must never break the banner */ }
  try {
    const payload = new Blob([JSON.stringify({ event })], { type: "application/json" });
    if (!navigator.sendBeacon || !navigator.sendBeacon(`${API}/promo/wednesday/track`, payload)) {
      fetch(`${API}/promo/wednesday/track`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ event }), keepalive: true,
      }).catch(() => {});
    }
  } catch (e) { /* tracking must never break the banner */ }
};

const getTimeLeft = () => {
  const now = new Date();
  if (now.getDay() !== 3) return null;
  const end = new Date(now);
  end.setHours(23, 59, 59, 999);
  const ms = end - now;
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  return { hours, minutes };
};

const WednesdayBanner = () => {
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const id = setInterval(() => setTimeLeft(getTimeLeft()), 30000);
    return () => clearInterval(id);
  }, []);

  const showBanner = !!timeLeft && !location.pathname.startsWith("/admin");
  useEffect(() => {
    if (showBanner) track("banner_view");
  }, [showBanner]);

  if (!showBanner) return null;

  return (
    <div
      data-testid="wednesday-banner"
      onClick={() => track("banner_click")}
      className="fixed bottom-0 left-0 right-0 z-[55] bg-brand-gold shadow-[0_-4px_20px_rgba(0,0,0,0.4)] cursor-default"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5">
        <p className="flex items-center gap-2 font-serif text-sm md:text-base font-semibold text-black text-center">
          <Sparkles size={15} className="text-black shrink-0" />
          Today Only — $60 Silk Press Special
          <Sparkles size={15} className="text-black shrink-0" />
        </p>
        <span data-testid="wednesday-banner-countdown" className="flex items-center gap-1.5 font-sans text-xs font-semibold text-black bg-black/10 border border-black/20 px-3 py-1 whitespace-nowrap">
          <Clock size={12} className="shrink-0" />
          {timeLeft.hours > 0 ? `${timeLeft.hours}h ${timeLeft.minutes}m left to book` : `${timeLeft.minutes}m left to book`}
        </span>
        <a
          href="/?service=svc-hb-silk-press-wednesday&promo=wed-banner#booking"
          data-testid="wednesday-banner-book-btn"
          onClick={(e) => { e.stopPropagation(); track("book_now_click"); }}
          className="bg-black text-brand-gold font-sans font-semibold text-xs px-5 py-1.5 hover:bg-black/80 transition-colors whitespace-nowrap"
        >
          Book Now
        </a>
      </div>
    </div>
  );
};

export default WednesdayBanner;
